// extracted by mini-css-extract-plugin
module.exports = {"userInfo":"UserInfo_userInfo__RZgiS","name":"UserInfo_name__WIc7P","avatar":"UserInfo_avatar__k9YIU","rate":"UserInfo_rate__3Bw9j"};